import { _t } from "../../languageHandler";

export enum LocationShareError {
    MapStyleUrlNotConfigured = "MapStyleUrlNotConfigured",
    MapStyleUrlNotReachable = "MapStyleUrlNotReachable",
    WebGLNotEnabled = "WebGLNotEnabled",
    Default = "Default",
}

export const getLocationShareErrorMessage = (errorType?: LocationShareError): string => {
    switch (errorType) {
        case LocationShareError.MapStyleUrlNotConfigured:
            return _t("location_sharing.MapStyleUrlNotConfigured");
        case LocationShareError.WebGLNotEnabled:
            return _t("location_sharing.WebGLNotEnabled");
        case LocationShareError.MapStyleUrlNotReachable:
        default:
            return _t("location_sharing.MapStyleUrlNotReachable");
    }
};
